(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pp-home-refills"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pp-home-refills')) {
    customElements.define('pp-home-refills', class extends HTMLElement {
      connectedCallback() {
        this.events?.abort();
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.querySelectorAll('[data-model-open]').forEach(link => {
          const dialog = this.querySelector(`[data-refill-dialog="${link.dataset.modelOpen}"]`);
          link.addEventListener('click', event => {
            if (!dialog?.showModal || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
            event.preventDefault();
            dialog.showModal();
          }, options);
          dialog.querySelector('[data-refill-close]').addEventListener('click', () => dialog.close(), options);
          dialog.addEventListener('click', event => {
            const bounds = dialog.getBoundingClientRect();
            if (event.target === dialog && (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom)) dialog.close();
          }, options);
          dialog.addEventListener('close', () => link.focus({ preventScroll: true }), options);
        });
        const rail = this.querySelector('[data-refill-rail]');
        const cards = [...rail.children];
        const previous = this.querySelector('[data-refill-prev]');
        const next = this.querySelector('[data-refill-next]');
        const counter = this.querySelector('[data-refill-count]');
        let current = 0;
        const update = () => {
          const step = cards[1].offsetLeft - cards[0].offsetLeft;
          current = step ? Math.min(cards.length - 1, Math.max(0, Math.round(rail.scrollLeft / step))) : 0;
          previous.disabled = current === 0;
          next.disabled = current === cards.length - 1;
          counter.textContent = `${current + 1} / ${cards.length}`;
        };
        const move = direction => {
          const target = Math.min(cards.length - 1, Math.max(0, current + direction));
          rail.scrollTo({ left: cards[target].offsetLeft - cards[0].offsetLeft, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        };
        previous.addEventListener('click', () => move(-1), options);
        next.addEventListener('click', () => move(1), options);
        rail.addEventListener('scroll', update, { ...options, passive: true });
        window.addEventListener('resize', update, options);
        this.querySelector('[data-refill-controls]').hidden = false;
        update();
      }
      disconnectedCallback() { this.events?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
